if (ApexChat.IsRoundedDynamicPlusTheme) {
    // Add Google Fonts dynamically in RD plus theme only
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap';
    document.head.appendChild(link);

    console.log('Google Fonts loaded dynamically!');
}